import { apiPost } from 'tennders-stracture/libs/api'

const useNotifSettings = () => {
  const saveNotifSettings = async (form) => apiPost('notification-settings', form)

  return { saveNotifSettings }
}

export default useNotifSettings
